// ShortCourseConstants

// helper constants
const SKILL_AND_CHECK_VARIABLES = [
    {id: 'checksEarned',displayName: 'Checks Earned',snippet: "{checksEarned}"},
    {id: 'checksLeft',displayName: 'Checks Left',snippet: "{checksLeft}"},
    {id: 'nodeStrongSkills',displayName: 'All strong skills from current skill node',snippet: "{nodeStrongSkills}"},
    {id: 'nodeWeakSkills',displayName: 'All weak skills from current skill node',snippet: "{nodeWeakSkills}"},
    {id: 'strongSkills',displayName: 'Strong skills from last activity',snippet: "{strongSkills}"},
    {id: 'weakSkills',displayName: 'Weak skills from last activity',snippet: "{weakSkills}"},
    {id: 'passedSkills',displayName: 'Passed skills from last activity',snippet: "{passedSkills}"},
    {id: 'failedSkills',displayName: 'Failed skills from last activity',snippet: "{failedSkills}"},
];

const PREVIOUS_ACTIVITY_VARIABLES = [
    {id: 'lastAssessment',          displayName: 'Previous Assessment Name',  snippet: "{lastAssessment}"},
    {id: 'previousActivityName',    displayName: 'Previous Activity Name',  snippet: "{previousActivityName}"},
];

    
// sub states for coach script advancement
const REPORT_CARD_PHASE = {
    START: 0,            // Nothing is checked. Nothing is emphasized.
    HIGHLIGHT_PASSED: 1, // Passed skills are emphasized and checked. Failed skills are greyed out
    HIGHLIGHT_FAILED: 2, // Passed skills are greyed out and checked. Failed skills are emphasized. 
    END: 3,              // Passed skills are checked. Nothing is emphasized. 
};

const COACH_SCRIPT_ID = {
    INTRO: 'intro_rich_text',
    // RECOMMENDATION_RICH_TEXT: 'recommendation_rich_text',
    // ATTEMPT_COMPLETED_RICH_TEXT: 'attempt_completed_rich_text',
    COURSE_COMPLETE: 'course_completed_rich_text',
    TUTORIAL: 'tutorial', // where the coach recommends the one and only tutorial activity
    NO_ATTEMPTS: 'no_attempts',
    ASSESSMENT_NOT_PASSED: 'assessment_not_passed',
    ASSESSMENT_PASSED: 'assessment_passed',
    REMEDIAL_ALL_PASSED: 'remedial_all_passed',
    REMEDIAL_SOME_PASSED: 'remedia_some_passed', // remedia_xxx = known typos but data referring to it already exists
    REMEDIAL_NOT_PASSED_TRY_OTHER: 'remedia_not_passed_try_other',
    REMEDIAL_NOT_PASSED_TRY_AGAIN: 'remedia_not_passed_try_again', 
    ATTEMPT_COMPLETE_ASSESSMENT_PERFECT: 'attempt_complete_assessment_perfect', // Scores were at 'perfect_score' or above in each objective    
    ATTEMPT_COMPLETE_ASSESSMENT_PASSED: 'attempt_complete_assessment_passed', 
    ATTEMPT_COMPLETE_ASSESSMENT_NEEDS_WORK: 'attempt_complete_assessment_needs_work', // passed some, failed some
    ATTEMPT_COMPLETE_ASSESSMENT_FAILED: 'attempt_complete_assessment_failed',
    ATTEMPT_COMPLETE_REMEDIATION_PASSED: 'attempt_complete_remediation_passed',
    ATTEMPT_COMPLETE_REMEDIATION_FAILED: 'attempt_complete_remediation_failed',
    NO_NEXT_ACTIVITY: 'no_next_activity',
};

const COACH_CONDITION = {
    firstCheck:         'firstCheck',
    firstStar:          'firstStar',
    firstCheckEver:     'firstCheckEver',
    firstStarEver:      'firstStarEver',
    noAdvancesNoChecks: 'noAdvancesNoChecks',
    advancedNoChecks:   'advancedNoChecks',
    oneOrMoreChecks:    'oneOrMoreChecks',
};

const AI_BOILERPLATE = {
    tutor_topLine: "You will be acting as a tutor named {botName} in a competency based course.", 
    tutor_courseSkillsLine: "This course has {numberOfSubskills} subskills. These subskills are: {subskillNames}",    
    tutor_focusSubskillParagraph: "This conversation will focus on subskill {focusSubskillName}.\n",
    tutor_rulesIntro: "Here are important rules about the conversation:\n",
    tutor_keepFocusRule: "Keep the conversation focused on {topicName}. If the student tries to go off-topic, turn the conversation back to {topicName}.\n",
    tutor_narrowFocusRule: "Please keep responses focused on as few aspects as possible, not expounding to cover all content in one response.\n",
    tutor_responseLengthRule: "Keep responses to 100 words or less.\n",
    tutor_notLastResponseRule: "End your response with an exploratory question about bias to test their knowledge in this context.\n",
    tutor_userFocusRule: "Keep these questions as related to the user as possible.\n",
    tutor_examplesRule: "When giving examples, try to focus on what they have experienced or their opinion.\n",
    tutor_askRatherThanTellRule: "Try not to teach them by telling them but by asking them exploratory questions.\n",
    tutor_endConversationRule: "When a student demonstrates that they understand {focusSubskillName}, please suggest that this conversation can end.\n",
    tutor_singleExampleReplyIntro: "Here is an example of how to reply:\n",
    tutor_multipleExampleRepliesIntro: "Here are some examples of how to reply:\n",
    tutor_offTopicExample: "<example>\nUser: I was wondering, are you made of cats?\nTutor: No cats were harmed in my creation, but let's discuss {topicName}. Can you ask me a question about {topicName} that I can clarify for you?\n</example>\n",
    tutor_onTopicExample: "<example>\nUser: I thought bias was always a negative thing.\nTutor: It is often the cause for us to make poor decisions, as we take mental shortcuts based on life experiences. \nWhile this can be helpful in avoiding harm, like bias against bees if you are allergic, it is not helpful when trying to make complex group decisions where you should be evaluating everyone's input based on the context of what they say, not who says it. Can you think of an example of when you don't listen to what someone is saying just because of who they are?\n</example>\n",
    tutor_responseFormat: `\
Your response should always be given in the following JSON format:\n{\n\
    "response": "Provide your response here",\n\
    "progress": "Provide a progress value from 0 to 100 indicating the student's progress",\n\
    "subskills": {\n\
        {subskillResponseFormatRows}\
    }\n\
}`, 
    tutor_subskillResponseRowFormat: "provide a progress value from 0 to 100 indicating the student's progress in {subskill}",

};

const ShortCourseConstants = {
    NODE_TYPES: {
        CompletionNode: 'completion',
        SkillNode: 'skill',
    },
    CompletionNodeID: 'completion', // singleton node
    PHRASE_VARIABLE_PREFIX: "phraseSet:",
    NAV_TYPES: {
        Settings: 'settings',
        Node: 'node',
        CoachScript: 'coach_script',
        RichText: 'rich_text', // for common rich text entries that can be used by different coach actions
        Comment: 'comments',
    },
    simpleFieldTypes: {
        'skill': {
            name: 'string',
            description: 'string',
            img_src: 'string',
        },
        'completion': {
            name: 'string',
            description: 'string',
            img_src: 'string',
        },
    },
    
    REPORT_CARD_PHASE: REPORT_CARD_PHASE,
    
    COACH_TEXTS: [
        { 
            id: COACH_SCRIPT_ID.INTRO, 
            displayName: 'Welcome Screen',
            oldBase: true, // for conversion from old data
            defaultText: "" },

// these two not used per Jeff
//      { id: 'recommendation_rich_text', displayName: 'Recommendation', oldBase: true, defaultText: "" },
//      { id:  'attempt_completed_rich_text', displayName: 'Attempt Completion', oldBase: true, defaultText: "<span>Attempt Completed</span>"  },

        { 
            id: COACH_SCRIPT_ID.COURSE_COMPLETE,
            displayName: 'Course Completion',
            oldBase: true, 
            defaultText: "<span>Course Completed</span>",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ]
        },

        {
            id: COACH_SCRIPT_ID.TUTORIAL, 
            displayName: 'Recommendations: Tutorial',
            defaultText: "Lets play the tutorial {nextActivityName}",
        },
    
        // texts for recommendation screen
        {   
            id: COACH_SCRIPT_ID.NO_ATTEMPTS, 
            displayName: 'Recommendations: No Attempts', 
            defaultText: "Lets go for our first star by playing {nextActivityName}",
            variableSnippets: [
                {id: 'nextActivityName',displayName: 'Next Activity Name',snippet: "{nextActivityName}"},
                ...SKILL_AND_CHECK_VARIABLES
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ASSESSMENT_PASSED, 
            displayName: 'Recommendations: Assessment Passed',
            defaultText: "Congratulations! Because you passed {previousActivityName} you are now ready to take {nextActivityName}",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ASSESSMENT_NOT_PASSED,
            displayName: 'Recommendations: Assessment Not Passed',
            defaultText: "Because you didn’t pass {previousActivityName} and you struggled with {failedSkillName}, let’s use this {nextActivityName} to build our skill.",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                {id: 'failedSkillName',        displayName: 'Failed Skill Name',        snippet: "{failedSkillName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_ALL_PASSED,
            displayName: 'Recommendations: Remedial All Passed',
            defaultText: "Because you improved your understanding while working in {previousActivityName}, you are now ready to take the {nextActivityName} and try again!",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_SOME_PASSED,
            displayName: 'Recommendations: Remedial Some Passed',
            defaultText: "While you were successful in {previousActivityName} during {lastAssessment} you struggled with {remediatingSkillName} so let’s work on that skill by playing {nextActivityName}.",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                {id: 'remediatingSkillName',    displayName: 'Remediating Skill Name',  snippet: "{remediatingSkillName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_OTHER,
            displayName: 'Recommendations: Remedial Not Passed, Try Something Else',
            defaultText: "Let's take a break from {previousActivityName} and build a different skill.  Let’s work on {nextActivityName}.",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_AGAIN, 
            displayName: 'Recommendations: Remedial Not Passed, Try Again',
            defaultText: "While you fell short on {failedSkillName} in the last attempt, let’s try {nextActivityName} again.",
            variableSnippets: [
                {id: 'nextActivityName',        displayName: 'Next Activity Name',      snippet: "{nextActivityName}"},
                {id: 'failedSkillName',         displayName: 'Failed Skill Name',        snippet: "{failedSkillName}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        
        // texts for attempt complete screen
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PERFECT, // Scores were at 'perfect_score' or above in each objective
            displayName: 'Attempt Complete: Assessment Perfect',
            defaultText: "That was perfect! Congratulations on earning a star!",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PASSED, 
            displayName: 'Attempt Complete: Assessment Passed',
            defaultText: "Congratulations on earning a star!",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_NEEDS_WORK, // passed some, failed some
            displayName: 'Attempt Complete: Assessment Needs Work',
            defaultText: "Sorry to say that you did not pass all criteria as needed.",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_FAILED,
            displayName: 'Attempt Complete: Assessment Failed',
            defaultText: "Sorry to say that you did not pass any of the criteria as needed.",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_PASSED,
            displayName: 'Attempt Complete: Remediation Passed',
            defaultText: "Well done brushing up on that skill",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_FAILED,
            displayName: 'Attempt Complete: Remediation Failed',
            defaultText: "Good work but looks like we still need to do a bit more.",
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES,
            ],
            canHaveSticker: true,
        },

        // remedial reminder (redmine #5851)
        {
            id: 'remedial_reminder',
            displayName: 'Remedial Reminder',
            defaultText: 'Based on your result you should revisit what "{remediatingSkillName}" is all about. {remediatingSkillDescription}. Think about areas where you may be able to improve next time',
            variableSnippets: [
                {id: 'nextActivityName',            displayName: 'Next Activity Name',              snippet: "{nextActivityName}"},
                {id: 'remediatingSkillName',        displayName: 'Remediating Skill Name',          snippet: "{remediatingSkillName}"},
                {id: 'remediatingSkillDescription', displayName: 'Remediating Skill Description',   snippet: "{remediatingSkillDescription}"},
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES
            ],
            canHaveSticker: false,
            common: true,
        },

        {
            id: 'report_card_skills_passed',
            displayName: 'Report Card Skills Passed Text',
            defaultText: 'You successfully met these criteria, doing exceptionally well in {strongSkills}',
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES
            ],
            canHaveSticker: false,
            common: true, // so it can be edited by the common rich text editor
            reportCard: true,
            phase: REPORT_CARD_PHASE.HIGHLIGHT_PASSED,
        },
        {
            id: 'report_card_skills_failed',
            displayName: 'Report Card Skills Failed Text',
            defaultText: 'Your performance did not meet expectations in these areas.',
            variableSnippets: [
                ...PREVIOUS_ACTIVITY_VARIABLES,
                ...SKILL_AND_CHECK_VARIABLES
            ],
            canHaveSticker: false,
            common: true, // so it can be edited by the common rich text editor
            reportCard: true,
            phase: REPORT_CARD_PHASE.HIGHLIGHT_FAILED,
        },
        
        {
            id: COACH_SCRIPT_ID.NO_NEXT_ACTIVITY,
            displayName: 'No Next Activity',
            defaultText: 'Course unable to proceed error. Unable to determine your next activity',
        },
    ], // COACH_TEXTS
    
    COACH_ACTIONS: [
        { type: "showRichText",         displayName: "Show Rich Text"}
            // additional_fields:
            //  rich_text_id                    // select rich text from dropdown
            //  coach_sticker_id,               // select coach sticker pose from dropdown
            //  showAdditionalRemedialSkills    // boolean
            //  showActivityElements            // boolean
    ],
    
    COACH_SCRIPTS: [
        {   
            id: COACH_SCRIPT_ID.INTRO, 
            displayName: 'Welcome Screen', 
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.INTRO }],
            options: [],
            deprecated: false, // hide from UI per redmine #6160, restore to UI per redmine #6198
        },
//        {   
//            id: COACH_SCRIPT_ID.RECOMMENDATION_RICH_TEXT, 
//            displayName: 'Recommendation', 
//            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.RECOMMENDATION_RICH_TEXT }]
//        },
//        {   
//            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETED_RICH_TEXT, 
//            displayName: 'Attempt Completion', 
//            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETED_RICH_TEXT }]
//        },
        {   
            id: COACH_SCRIPT_ID.COURSE_COMPLETE, 
            displayName: 'Course Completion', 
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.COURSE_COMPLETE }],
            options: [],
        },

        {
            id: COACH_SCRIPT_ID.TUTORIAL, 
            displayName: 'Recommendations: Tutorial', 
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.TUTORIAL,    coach_sticker_id:COACH_SCRIPT_ID.TUTORIAL, showActivityElements:true}],
            options: ['showActivityElements'],
        },
    
        {   
            id: COACH_SCRIPT_ID.NO_ATTEMPTS,  
            displayName: 'Recommendations: No Attempts', 
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.NO_ATTEMPTS,    coach_sticker_id:COACH_SCRIPT_ID.NO_ATTEMPTS, showActivityElements:true}],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.ASSESSMENT_PASSED, 
            displayName: 'Recommendations: Assessment Passed',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ASSESSMENT_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.ASSESSMENT_PASSED, showActivityElements:true}],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.ASSESSMENT_NOT_PASSED,
            displayName: 'Recommendations: Assessment Not Passed',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ASSESSMENT_NOT_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.ASSESSMENT_NOT_PASSED, showActivityElements: true}],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_ALL_PASSED,
            displayName: 'Recommendations: Remedial All Passed',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.REMEDIAL_ALL_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.REMEDIAL_ALL_PASSED, showActivityElements: true,}],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_SOME_PASSED,
            displayName: 'Recommendations: Remedial Some Passed',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.REMEDIAL_SOME_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.REMEDIAL_SOME_PASSED, showActivityElements: true, }],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_OTHER,
            displayName: 'Recommendations: Remedial Not Passed, Try Something Else',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_OTHER,    coach_sticker_id:COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_OTHER, showActivityElements: true, }],
            options: ['showActivityElements'],
        },
        {
            id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_AGAIN,
            displayName: 'Recommendations: Remedial Not Passed, Try Again',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_AGAIN,    coach_sticker_id:COACH_SCRIPT_ID.REMEDIAL_NOT_PASSED_TRY_AGAIN, showActivityElements: true,  }],
            options: ['showActivityElements'],
        },
        
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PERFECT,
            displayName: 'Attempt Complete: Assessment Perfect',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PERFECT,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PERFECT}],
            showCriteriaScores: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PASSED,
            displayName: 'Attempt Complete: Assessment Passed',
            actions: [{type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_PASSED},],
            showCriteriaScores: true,
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_NEEDS_WORK,
            displayName: 'Attempt Complete: Assessment Needs Work',
            actions: [
                {type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_NEEDS_WORK,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_NEEDS_WORK},
                {type: 'showRichText',  rich_text_id: 'remedial_reminder',    coach_sticker_id:'remedial_reminder', 
                    showAdditionalRemedialSkills: true},
            ],
            showCriteriaScores: true,
            options: ['showAdditionalRemedialSkills'],
            
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_FAILED,
            displayName: 'Attempt Complete: Assessment Failed',
            actions: [
                {type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_FAILED,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_ASSESSMENT_FAILED},
                {type: 'showRichText',  rich_text_id: 'remedial_reminder',    coach_sticker_id:'remedial_reminder',
                    showAdditionalRemedialSkills: true},
            ],
            showCriteriaScores: true,
            options: ['showAdditionalRemedialSkills'],
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_PASSED,
            displayName: 'Attempt Complete: Remediation Passed',
            actions: [
                {type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_PASSED,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_PASSED,
                    showAdditionalRemedialSkills: true},
            ],
            showCriteriaScores: true,
            options: ['showAdditionalRemedialSkills'],
        },
        {
            id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_FAILED,
            displayName: 'Attempt Complete: Remediation Failed',
            actions: [
                {type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_FAILED,    coach_sticker_id:COACH_SCRIPT_ID.ATTEMPT_COMPLETE_REMEDIATION_FAILED},
                {type: 'showRichText',  rich_text_id: 'remedial_reminder',    coach_sticker_id:'remedial_reminder', 
                    showAdditionalRemedialSkills: true}
            ],
            showCriteriaScores: true,
            options: ['showAdditionalRemedialSkills'],
        },
        {
            id: COACH_SCRIPT_ID.NO_NEXT_ACTIVITY,
            displayName: 'Error Situation: No next activity',
            actions: [
                {type: 'showRichText',  rich_text_id: COACH_SCRIPT_ID.NO_NEXT_ACTIVITY},
            ],
        }
    ], // COACH_SCRIPTS
    
    SPECIAL_STICKERS: [
        { id:'upper_sticker_shape',  displayName: 'Upper Partial Shape'}, // used to flow upper rich text around coach sticker *** NO LONGER USED ***
        { id:'lower_sticker_shape',  displayName: 'Lower Partial Shape'}, // used to flow lower rich text around coach sticker
    ],
    
    TABLE_TEMPLATES: [{
        name: "criteria_scores",
        title: "Criteria Scores",
        numRows: 2,
        numColumns:2,
        cellData: [
            [{expression:"Criteria Scores",plainText:true}, {expression:"",plainText:true}],
            [{expression:"Score N",skipEval:true},    {expression:"Skill N",skipEval:true}], // this row will be replicated depending on number of skills
        ],
    }],
    
    COACH_SCRIPT_ID: COACH_SCRIPT_ID,
    COACH_CONDITION: COACH_CONDITION,
    AI_BOILERPLATE,
};


module.exports = ShortCourseConstants;